var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-content"},[_c('ul',{staticClass:"itemLists"},_vm._l((_vm.dataLists),function(item){return _c('li',{key:item.name,staticClass:"item",on:{"click":function($event){return _vm.showDetailDialog(item)}}},[_c('h3',[_vm._v(_vm._s(item.count))]),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }